module.exports = __webpack_public_path__ + "img/default.38c29731.jpg";